var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { hasTimestamps } from "../traits/hasTimestamps.trait";
export var makeContactForm = function () { return (__assign({ id: '', userId: null, name: '', email: '', phone: '', type: '', body: '', timeRead: '' }, hasTimestamps())); };
